import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';

import { staffNotificationsApi } from '../api/production-api';

import { productionKeys } from './production-keys';

export const NOTIFICATION_POLL_MS = 60_000;
const BELL_PAGE_SIZE = 20;

/** The bell appends pages with "Load more"; every page carries the member's unread count. */
export function staffNotificationsQueryOptions(unreadOnly: boolean) {
  return infiniteQueryOptions({
    queryKey: productionKeys.notifications(unreadOnly),
    queryFn: ({ pageParam }) =>
      staffNotificationsApi.list({
        limit: BELL_PAGE_SIZE,
        ...(unreadOnly ? { unread: 'true' } : {}),
        ...(pageParam ? { cursor: pageParam } : {}),
      }),
    initialPageParam: '',
    getNextPageParam: (last) => last.nextCursor ?? undefined,
  });
}

/** The bell polls once a minute; the backend has no push channel for in-app alerts. */
export function useStaffNotifications(unreadOnly = false) {
  return useInfiniteQuery({
    ...staffNotificationsQueryOptions(unreadOnly),
    refetchInterval: NOTIFICATION_POLL_MS,
  });
}
